import { getRoutesData, saveRoutesData } from "./storage";
import { Routes, RoutesStorageInterface } from "./interfaces";

export const getProjectsCurrentPage = (): string => {
  const data = getRoutesData();
  return data[Routes.PROJECTS]?.currentPage ?? "0";
};
export const setProjectsCurrentPage = (pageNumber: string): void => {
  const data = getRoutesData();

  const updatedData: RoutesStorageInterface = {
    ...data,
    [Routes.PROJECTS]: { currentPage: pageNumber }
  };

  saveRoutesData(updatedData);
};
